import moment from 'moment';
class LogShippingTokenModelManipulator {
    getFormattedCreatedAt(logShippingToken) {
        return moment.unix(logShippingToken?.createdAt).format('llll');
    }
}
export const logShippingTokenModelManipulator = new LogShippingTokenModelManipulator();
//# sourceMappingURL=log-shipping-token.manipulator.js.map